import React from "react";
import TabBox from "src/Components/Tabbox/TabBox";
import Loading from "src/Components/Loading/Loading";
import { message } from "antd";
import ConsumerParametersTab from "./ConsumerParametersTab";
const VolatilityTab=React.lazy(() => import("src/Pages/MarketHistory/Analytics/VolatilityTab"));
const FundBubbleTab=React.lazy(() => import("src/Pages/MarketHistory/Analytics/FundBubbleTab"));
const InterestRateTab=React.lazy(() => import("./InterestRateTab"));
const DividendYieldTab=React.lazy(() => import("./DividendYieldTab"));
const tabs=[{index:0,title:"تنظیمات بخش‌ها"},{index:1,title:"نوسان‌پذیری"},{index:2,title:"حباب صندوق"},{index:3,title:"نرخ بهره"},{index:4,title:"بازده نقدی"}];
export default function SystemParameters() {
  const [tab,setTab]=React.useState(0);
  const [dirty,setDirty]=React.useState(false);
  const changeTab=(_:string|undefined,index:number)=>{
    if(index===tab)return;
    if(dirty){message.warning("ابتدا تغییرات را ذخیره یا لغو کنید.");return;}
    setTab(index);
  };
  return <div className="w-full p-5 flex flex-col gap-5" dir="rtl">
    <div className="w-fit max-w-full overflow-x-auto"><TabBox activeTab={tab} onChange={changeTab}>{tabs}</TabBox></div>
    <React.Suspense fallback={<div className="flex justify-center p-6"><Loading className="!text-sky-600" /></div>}>
      {tab===0?<ConsumerParametersTab onDirtyChange={setDirty} />:tab===1?<VolatilityTab />:tab===2?<FundBubbleTab />:tab===3?<InterestRateTab />:<DividendYieldTab />}
    </React.Suspense>
  </div>;
}
